export default {
  Enter: 13,
  Tab: 9,
  Down: 40,
  Up: 38,
  ESC: 27,
  ArrowRight: 39,
  ArrowLeft: 37,
  Space: 32,
  F2: 113,
  Delete: 46,
  Insert: 45,
  Digit2: 50,
  NumberPad2: 98,
};
